// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1G6Wy","footerLinks":"Footer_footerLinks__vYW8Z"};